import React from 'react'

const ApplyButton = ({ text , onClick }) => {
    return (
        <button onClick={onClick}
         className="cursor-pointer bg-[#FFA201] px-6 py-2 rounded-none text-black text-[14px]  hover:bg-[#e89500] transition">
            {text}
        </button>
    )
}

export default ApplyButton